<template>
  <PageWrapper :isLoading="isLoading" isExtended>
    <template #title> جزئیات سفارش {{ $route.params.id }} </template>
    <template #titleBtn>
      <template v-if="orderDetails">
        تاریخ ثبت:
        {{ new Date(orderDetails.createDate).toLocaleDateString("fa-IR") }}
      </template>
    </template>
    <template #extend>
      <BRow v-if="orderDetails">
        <BCol cols="12">
          وضعیت سفارش:
          <BButton
            size="sm"
            @click="renderOrderStatusModal"
            style="padding: 0.6rem 0.7rem"
            :variant="handleStatusChipColor"
          >
            {{ orderStatuses[orderDetails.status] }}
          </BButton>
        </BCol>
        <BCol cols="12" class="my-2">
          متعلق به :
          <b-link :to="`/users/${orderDetails.userInfo.userId}`">
            {{ orderDetails.userInfo.fullName }}
          </b-link>
        </BCol>
        <BCol cols="12">
          <p>
            مبلغ سفارش:
            {{
              orderDetails.sumPrice
                ? Intl.NumberFormat("en-US").format(orderDetails.sumPrice)
                : 0
            }}
            تومان
          </p>
          <p v-if="orderDetails.sumPriceAfterDiscount">
            مبلغ سفارش بعد از تخفیف:
            {{
              Intl.NumberFormat("en-US").format(
                orderDetails.sumPriceAfterDiscount
              )
            }}
            تومان
          </p>
          <template v-if="orderDetails.masterCodeDiscountValue">
            <p>
              تخفیف اعمال شده:
              {{
                Intl.NumberFormat("en-US").format(
                  orderDetails.masterCodeDiscountValue
                )
              }}
              تومان
              <b-link
                :to="`/apps/referral-discounts/${orderDetails.masterCodeDiscountId}`"
              >
                کد ریفر استاد
              </b-link>
            </p>
          </template>
        </BCol>
      </BRow>
    </template>
    <CustomTable
      v-if="orderDetails"
      :pageNumber="1"
      :count="100"
      :totalCount="0"
      :tableColumns="tableColumns"
      :tableItems="orderDetails.subOrders"
      @changePage="() => {}"
    >
      <template #productType="data">
        {{ checkSubOrderType(data.item) }}
      </template>
      <template #title="data">
        {{ checkSubOrderTitle(data.item) }}
      </template>
      <template #price="data">
        {{ checkSubOrderPrice(data.item) }}
      </template>
      <template #discountedPrice="data">
        {{ checkSubOrderDiscount(data.item) }}
      </template>
      <template #actions="data">
        <b-link nuxt :to="handleSubOrderLink(data.item)"> مشاهده محصول </b-link>
      </template>
    </CustomTable>
    <UpdateOrderStatusDialog
      v-if="orderDetails"
      :orderId="$route.params.id"
      :currentOrderStatus="orderDetails.status"
      @refetch="getOrderById"
    ></UpdateOrderStatusDialog>
  </PageWrapper>
</template>
<script>
export default {
  mounted() {
    this.getOrderById();
  },
  data() {
    return {
      tableColumns: [
        {
          label: "نوع محصول",
          key: "productType",
        },
        {
          label: "عنوان محصول",
          key: "title",
        },
        {
          label: "نام استاد",
          key:"masterScheduleTitle"
        },
        {
          label: "تعداد",
          key:"count"
        },
        {
          label: "هزینه محصول",
          key: "price",
        },
        // {
        //   label: "مشاهده محصول",
        //   key: "actions",
        // },

      ],
      newOrderStatus: null,
      isLoading: false,
      orderDetails: null,
      orderStatuses: {
        1: "ثبت شده",
        2: "پرداخت شده",
        3: "ارسال شده",
        4: "تحویل شده",
        5: "کنسل شده",
      },
    };
  },
  methods: {
    async changeThisOrderStatus() {
      try {
        this.isLoading = true;
        let _this = this;
        let changeOrderStatus = new ChangeOrderStatus(_this);
        changeOrderStatus.setRequestParam({
          orderId: _this.$route.params.id,
          status: _this.newOrderStatus,
        });
        await changeOrderStatus.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "وضعیت سفارش با موفقیت تغییر کرد",
                icon: "EditIcon",
                variant: "success",
              },
            });
            _this.getOrderById();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    renderOrderStatusModal() {
      this.$bvModal.show("update-order-status-dialog");
    },
    checkSubOrderType(subOrder) {
      if (subOrder.courseInfo) {
        return "دوره";
      } else if (!subOrder.courseInfo && subOrder.lessonInfo) {
        return "درس";
      } else if (
        !subOrder.courseInfo &&
        !subOrder.lessonInfo &&
        subOrder.lessonCategoryId
      ) {
        return "گروه درس";
      } else {
        return "-";
      }
    },
    checkSubOrderTitle(subOrder) {
      if (subOrder.courseInfo) {
        return subOrder.courseInfo.title;
      } else if (!subOrder.courseInfo && subOrder.lessonInfo) {
        return subOrder.lessonInfo.title;
      } else if (
        !subOrder.courseInfo &&
        !subOrder.lessonInfo &&
        subOrder.lessonCategoryId
      ) {
        return subOrder.lessonCategoryInfo?.title || "-";
      }
      return "-";
    },
    checkSubOrderPrice(subOrder) {
      if (subOrder.amount) {
        return `${Intl.NumberFormat("en-US").format(subOrder.amount)} تومان`;
      } else {
        return "-";
      }
    },
    checkSubOrderDiscount(subOrder) {
      if (subOrder.amountAfterDiscount) {
        return `${Intl.NumberFormat("en-US").format(
          subOrder.amountAfterDiscount
        )} تومان`;
      } else {
        if (subOrder.lessonCategoryId) {
          return `${Intl.NumberFormat("en-US").format(
            this.orderDetails.sumPriceAfterDiscount
          )} تومان`;
        }
        return `-`;
      }
    },
    handleSubOrderLink(subOrder) {
      if (subOrder.courseInfo) {
        return `/courses/${subOrder.courseInfo.courseId}`;
      } else if (!subOrder.courseInfo && subOrder.lessonInfo) {
        if (subOrder.lessonInfo.justBasic) {
          return `/independent-lessons/${subOrder.lessonInfo.lessonId}`;
        } else {
          return `/lessons/${subOrder.lessonInfo.lessonId}`;
        }
      }
    },
    async getOrderById() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleOrder = new GetASingleOrder(_this);
        getASingleOrder.setRequestParam({
          orderId: _this.$route.params.id,
        });
        await getASingleOrder.fetch(function (response) {
          if (response.isSuccess) {
            _this.orderDetails = response.data;
            _this.newOrderStatus = response.data.status;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    handleStatusChipColor() {
      if (this.orderDetails) {
        switch (this.orderDetails.status) {
          case 1:
            return "warning";
          case 2:
            return "success";
          case 5:
            return "error";
        }
      }
    },
  },
  components: {
    BRow,
    BCol,
    BButton,
    BLink,
    PageWrapper,
    UpdateOrderStatusDialog,
    CustomTable,
  },
};
import { GetASingleOrder, ChangeOrderStatus } from "@/libs/Api/Order";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { BRow, BCol, BButton, BLink } from "bootstrap-vue";

import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import UpdateOrderStatusDialog from "@/views/components/Orders/UpdateOrderStatusDialog.vue";
</script>
